import React, { useState, useEffect, useCallback, useMemo } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  MasterDetail,
  Pager,
  Paging,
  Button,
  StateStoring,
  ColumnFixing,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import Guid from "devextreme/core/guid";
import { useStyles } from "../../Styles.js";
import CustomStore from "devextreme/data/custom_store";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button1 from "@material-ui/core/Button";
import { api_path } from "../../shared.js";
import Select from "react-select";
import axios from "axios";
import swal from "sweetalert";
import TextField from "@material-ui/core/TextField";
import DateBox from "devextreme-react/date-box";
import SaleOrderMasterDetailView from "./SaleOrderMasterDetailView";
import ship_green from "../../assets/ship_green.svg";
import ship_red from "../../assets/ship_red.svg";
import OrderLogDataView from "./OrderLogItemView";
import Modal from "react-bootstrap/Modal";
import useDeviceSize from "../../hooks/useDeviceSize";
import { loadDropdownWithAutoSelect } from "../../api/dropdownUtils";
export function SalesOrderDataGrid(props) {
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
    // const [getUserRole] = useState(1);
    // const [getCrmId, setCrmId] = useState('94');
    // const [getUserID, setUserID] = useState('raweenun.m@sinologistics.co.th');
    //    const [getEmpCode] = useState('3127');
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  const classes = useStyles();
  const [GET_REFNO, SET_REFNO] = useState("");
  const [GET_BOOKNO, SET_BOOKNO] = useState("");
  const [GET_SMFREF, SET_SMFREF] = useState("");
  const [getLoadGrid, setLoadGrid] = useState();
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [getShipper, setShipper] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  const [selectShipper, setSelectShipper] = useState([]);
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [getTotalCount, setTotalCount] = useState(0);
  const [getStatus, setStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [consigneeList, setConsigneeList] = useState([]);
  const [selectConsignee, setSelectConsignee] = useState([]);
  const [getConsignee, setConsignee] = useState([]);
  const [getResult, setResult] = useState("");
  const [getErrMsg, setErrMsg] = useState("");
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);
  const [getSaleAuthenCode, setSaleAuthenCode] = useState("");
  const pageSizes = [25, 50, 100];
  const [selectedValue, setSelectedValue] = useState("option1");
  const [getDateStr, setDateStr] = useState("");
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  const past30Days = new Date(date);
  past30Days.setDate(past30Days.getDate() - 30);
  var firstDay = past30Days; // ✅ ตอนนี้เป็น Date object แล้ว

  var lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const [showLog, setShowLog] = useState(false);
  const handleCloseLog = () => setShowLog(false);
  const handleShowLog = () => setShowLog(true);
  const [logData, setLogData] = useState([]);
  useEffect(() => {
    setResult("");
    if (getUserRole == 1) {
        fetchSale();
        setSelectSale(getCrmId);
        setSale({
          SALE_NAME: getUserID,
        });
      // setSelectSale(getCrmId);
      // setSale({
      //   SALE_CODE: getCrmId,
      //   SALE_NAME: getUserID,
      // });
    } else if (getUserRole == 2) {
      fetchSale();
      if (localStorage.getItem("getSelectSale")) {
        let sale = localStorage.getItem("getSelectSale");
        let sale_label = localStorage.getItem("getSelectSalelabel");
        setSelectSale(sale);
        setSale({ SALE_CODE: sale, SALE_NAME: sale_label });
      } else {
        setSelectSale("10000000");
      }
    } else if (getUserRole == 3 || getUserRole == 7) {
      fetchSale();
      setUserID("");
    }
    if (localStorage.getItem("getSelectStatus")) {
      let stutus = localStorage.getItem("getSelectStatus");
      let stutus_label = localStorage.getItem("getSelectStatuslabel");
      setSelectStatus(stutus);
      setStatus({ value: stutus, label: stutus_label });
    }

    if (localStorage.getItem("getSelectShipper")) {
      let shipper = localStorage.getItem("getSelectShipper");
      let shipper_label = localStorage.getItem("getSelectShipperlabel");
      setSelectShipper(shipper);
      setShipper({ COM_CODE: shipper, COM_NAME: shipper_label });
    }
    if (localStorage.getItem("getSelectConsignee")) {
      let Consignee = localStorage.getItem("getSelectConsignee");
      let Consignee_label = localStorage.getItem("getSelectConsigneelabel");
      setSelectConsignee(Consignee);
      setConsignee({ COM_CODE: Consignee, COM_NAME: Consignee_label });
    }
  }, []);
  const optionsStatus = [
    { value: "0", label: "Draft" },
    { value: "1", label: "New" },
    { value: "2", label: "Received" },
    { value: "3", label: "Reject" },
    { value: "4", label: "Wait Carrier Release" },
    { value: "5", label: "Wait Sales to confirm" },
    { value: "6", label: "Sales confirm" },
    { value: "7", label: "BSE Created" },
    { value: "10", label: "BSE Confirmed" },
    { value: "11", label: "Open Job" },
    //{ value: "8", label: "BSE Pre Confirmed" },
    { value: "9", label: "Cancel" },
  ];
  const optionsButton = [
    { value: "1", label: "New FCL" },
    { value: "2", label: "New from BSE/BSI (FCL)" },
    { value: "3", label: "New LCL" },
    { value: "4", label: "New from BSE/BSI (LCL)" },
  ];
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
    localStorage.setItem("getSelectStatus", obj.value);
    localStorage.setItem("getSelectStatuslabel", obj.label);
  };
  const handleButtonNewChange = (obj) => {
    if (obj.value == "1") {
      window.open("/s-crm/SalesOrderForm?type=1&loadtype=fcl", "_blank");
    } else if (obj.value == "2") {
      window.open("/s-crm/SalesOrderForm?type=2&loadtype=fcl", "_blank");
    } else if (obj.value == "3") {
      window.open("/s-crm/SalesOrderForm?type=1&loadtype=lcl", "_blank");
    } else if (obj.value == "4") {
      window.open("/s-crm/SalesOrderForm?type=2&loadtype=lcl", "_blank");
    } else {
      window.open("/s-crm/SalesOrderForm?type=1&loadtype=fcl", "_blank");
    }
  };
  const onValueChangedDateFrom = React.useCallback((e) => {
    setSearchStatus(0);
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    setSearchStatus(0);
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
  }, []);
  function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString("default", { day: "2-digit" });
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.toLocaleString("default", { year: "numeric" });
    return day + "-" + month + "-" + year;
  }
  const handleSearch = (e) => {
    //setLoadGrid(randomNumberInRange(1, 20));
  };
  const handleClearInputClick = () => {
    setDateStr("Please click Search button to refresh data.");
    if (getUserRole == 1) {
      setSelectSale(getCrmId);
      setSale({
        SALE_CODE: getCrmId,
        SALE_NAME: getUserID,
      });
      setSaleAuthenCode(getEmpCode);
    } else if (getUserRole == 3) {
      setSale([]);
      setSelectSale([]);
    }
    setStatus([]);
    setSelectStatus([]);
    setShipper([]);
    setSelectShipper([]);
    setConsignee([]);
    setSelectConsignee([]);
    setResult("");
    setDateStr("");
    setTotalCount(0);
    localStorage.removeItem("getSelectStatus");
    localStorage.removeItem("getSelectStatuslabel");
    localStorage.removeItem("getSelectShipper");
    localStorage.removeItem("getSelectShipperlabel");
    localStorage.removeItem("getSelectConsignee");
    localStorage.removeItem("getSelectConsigneelabel");
    localStorage.removeItem("getSelectSale");
    localStorage.removeItem("getSelectSalelabel");
    localStorage.removeItem("currentSelectedRowKeys");
  };

  const styles = {
    radioButton: {
      padding: "12px 16px",
      borderRadius: "8px",
      margin: "8px",
      border: "2px solid #007BFF",
      background: "#fff",
      display: "inline",
      alignItems: "center",
      justifyContent: "center",
      width: "280px",
      cursor: "pointer",
      transition: "background-color 0.3s, color 0.3s",
    },
    selected: {
      background: "#007BFF",
      color: "#fff",
      borderColor: "#007BFF",
    },
    list: {
      listStyleType: "none",
      padding: 0,
      textAlign: "center",
      display: "inline-flex",
    },
  };
  const token = process.env.REACT_APP_API_TOKEN;
  const salesOrderDataSource = useMemo(() => {
    return new CustomStore({
      key: "ORDER_ID",
      load: async (loadOptions) => {
        // เริ่มจับเวลา UI + API
        const uiStart = performance.now();
        const filters = JSON.stringify(loadOptions.filter ?? []);
        const params = {
          crmid: getCrmId,
          status: selectStatus,
          sale: selectSale,
          shipper: selectShipper,
          cnee: selectConsignee,
          bookref: GET_REFNO,
          bookno: GET_BOOKNO,
          smfref: GET_SMFREF,
          parDateFrom: getDateFrom,
          parDateTo: getDateTo,
          load: getLoadGrid,
          skip: loadOptions.skip ?? 0,
          take: loadOptions.take ?? 5000,
          sortField: loadOptions.sort?.[0]?.selector ?? "ORDER_DATE",
          sortOrder: loadOptions.sort?.[0]?.desc !== false ? "DESC" : "ASC",
          filters, // 👈 แปลง filter เป็น JSON string ส่งไป
        };
        //console.log("📦 Params ที่ส่งไป:", params);
        const queryString = new URLSearchParams(params).toString();
        //console.log("🔗 Query String:", queryString);
        const apiStart = performance.now();
        const response = await fetch(
          api_path + `/sales-order-sales-paging.php?${queryString}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();

        const apiEnd = performance.now();
        const apiTime = ((apiEnd - apiStart) / 1000).toFixed(3);
        //CLEAN DATA TIME
        const cleanStart = performance.now();
        const cleanData = result.data.map((item) => ({
          ...item,
          CNEE_NAME: item.CNEE_NAME?.trim() || "(ไม่มีข้อมูล)",
          SHIPPER_NAME: item.SHIPPER_NAME?.trim() || "(ไม่มีข้อมูล)",
          AGENT_NAME: item.AGENT_NAME?.trim() || "(ไม่มีข้อมูล)",
          COLOAD_NAME: item.COLOAD_NAME?.trim() || "(ไม่มีข้อมูล)",
          CS_NAME: item.CS_NAME?.trim() || "(ไม่มีข้อมูล)",
          SALE_NAME: item.SALE_NAME?.trim() || "(ไม่มีข้อมูล)",
          LAST_UPDATE: item.LAST_UPDATE || "-",
          SO_STATUS: item.SO_STATUS?.trim() || "(ไม่มีสถานะ)",
          BOOK_NO: item.BOOK_NO?.trim() || "-",
          REF_NO: item.REF_NO?.trim() || "-",
          SMF_REF: item.SMF_REF?.trim() || "-",
        }));
        const cleanEnd = performance.now();
        const cleanTime = ((cleanEnd - cleanStart) / 1000).toFixed(3);

        // ⏱ TOTAL UI LOAD TIME (API + CLEAN DATA)
        const uiEnd = performance.now();
        const totalUiTime = ((uiEnd - uiStart) / 1000).toFixed(3);

        console.log(
          "%c================ PERFORMANCE ================",
          "color:#9333ea;font-weight:bold;"
        );
        console.log("⏱ API Response Time       =", apiTime + " sec");
        console.log("⏱ Clean Data Time         =", cleanTime + " sec");
        console.log("⏱ UI Load (Total)         =", totalUiTime + " sec");
        console.log(
          "⏱ React Render Wait (EST) =",
          (totalUiTime - apiTime - cleanTime).toFixed(3) + " sec"
        );
        console.log("══════════════════════════════════════════════");
        return {
          data: cleanData,
          totalCount: result.totalCount ?? 0,
        };
      },
    });
  }, [
    getCrmId,
    selectStatus,
    selectSale,
    selectShipper,
    selectConsignee,
    GET_REFNO,
    GET_BOOKNO,
    GET_SMFREF,
    getDateFrom,
    getDateTo,
    getLoadGrid,
    token,
  ]);
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const fetchSale = async () => {
    try {
      const response = await axios.get(`${api_path}/GET_SALES.php`, {
        params: {
          role: getUserRole,
          user: getCrmId,
        },
      });
      const saleData = response.data;
      setSaleList(saleData);

      //ถ้ามีตัวเลือกเดียว ให้ตั้งค่าทันที
      if (saleData.length === 1) {
        setSelectSale(saleData[0].SALE_CODE);
        setSale({
          SALE_CODE: saleData[0].SALE_CODE,
          SALE_NAME: saleData[0].SALE_NAME,
        });
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };
  const handleSaleChange = (obj) => {
    if (obj) {
      setSelectSale(obj.SALE_CODE);
      setSale({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
      localStorage.setItem("getSelectSale", obj.SALE_CODE);
      localStorage.setItem("getSelectSalelabel", obj.SALE_NAME);
    } else {
      setSelectSale([]);
      setSale([]);
      localStorage.removeItem("getSelectSale");
      localStorage.removeItem("getSelectSalelabel");
    }
  };
  useEffect(() => {
    if (!getSale.SALE_CODE) return;
    const getShipperDropdown = async () => {
      const res = await fetch(
        `${api_path}/TMP_SMBUSINESS.php?SALES_CODE=${getSale.SALE_CODE}&TYPE=SHIPPER`
      );
      const data = await res.json();
      setShipperList(data);
    };
    getShipperDropdown();
  }, [getSale.SALE_CODE]);
  const handleShipperChange = (obj) => {
    setSelectShipper(obj.COM_CODE);
    setShipper({
      COM_CODE: obj.COM_CODE,
      COM_NAME: obj.COM_NAME,
    });
    localStorage.setItem("getSelectShipper", obj.COM_CODE);
    localStorage.setItem("getSelectShipperlabel", obj.COM_NAME);
  };
  useEffect(() => {
    if (!getSale?.SALE_CODE) return;
    const getCNEEDropdown = async () => {
      try {
        const res = await fetch(
          `${api_path}/TMP_SMBUSINESS.php?SALES_CODE=${getSale.SALE_CODE}&TYPE=CONSIGNEE`
        );
        const data = await res.json();
        setConsigneeList(data);
      } catch (error) {
        console.error("Error fetching consignee list:", error);
      }
    };
    getCNEEDropdown();
  }, [getSale?.SALE_CODE]);
  const handleConsigneeChange = (obj) => {
    setSelectConsignee(obj.COM_CODE);
    setConsignee({
      COM_CODE: obj.COM_CODE,
      COM_NAME: obj.COM_NAME,
    });
    localStorage.setItem("getSelectConsignee", obj.COM_CODE);
    localStorage.setItem("getSelectConsigneelabel", obj.COM_NAME);
  };
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const onDeleteButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    swal({
      title: "Are you sure to delete this order ?",
      text: "",
      icon: "info",
      dangerMode: false,
      buttons: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        delBooking(e.row.key);
      }
    });
  }, []);
  const delBooking = async (id) => {
    try {
      const response = await axios.delete(
        api_path + `/TS_SALES_ORDER.php?order_id=${id}`
      );
      setLoadGrid(randomNumberInRange(1, 20));
    } catch (error) {
      console.error(error);
    }
  };

  const onCopyButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open(
      "/s-crm/SalesOrderForm?copy_id=" +
        e.row.key +
        "&loadtype=" +
        dataRow.LOADTYPE,
      "_blank"
    );
  }, []);
  const onEditButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open(
      "/s-crm/SalesOrderForm?order_id=" +
        e.row.key +
        "&loadtype=" +
        dataRow.LOADTYPE,
      "_blank"
    );
  }, []);
  const onBookingButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open(
      "/s-crm/SalesOrderDetail?order_id=" +
        e.row.key +
        "&loadtype=" +
        dataRow.LOADTYPE,
      "_blank"
    );
  }, []);
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "SalesOrder.xlsx"
        );
      });
    });
  };
  // const cellPrepared = (e) => {
  //   if (e.rowType !== "data") return;

  //   const { data, column, cellElement, row } = e;

  //   // Helper: render image icons
  //   const renderShipIcons = (count, iconSrc) => {
  //     const iconCount = parseInt(count, 10) || 0;
  //     return Array(iconCount)
  //       .fill(`<img src="${iconSrc}" width="16" />`)
  //       .join("");
  //   };

  //   // ORDER_STATUS_NAME: สีตาม status
  //   if (column.dataField === "ORDER_STATUS_NAME") {
  //     const textColor = data.ORDER_STATUS === "0" ? "#000000" : "#FFFFFF";
  //     cellElement.innerHTML = `
  //     <p class="status${data.ORDER_STATUS}">
  //       <a href="SalesOrderDetail?order_id=${row.key}" title="View Order" target="_blank" style="color:${textColor};">
  //         ${data.ORDER_STATUS_NAME}
  //       </a>
  //     </p>`;
  //   }

  //   // ORDER_NO: ตรงกลาง สีเทา
  //   else if (column.dataField === "ORDER_NO") {
  //     cellElement.innerHTML = `
  //     <p style="color:#000; background-color:#EBEBEB; text-align:center;">
  //       <a href="SalesOrderDetail?order_id=${row.key}" title="View Order" target="_blank" style="color:#000;">
  //         ${data.ORDER_NO}
  //       </a>
  //     </p>`;
  //   }

  //   // ACTIVE_ITEM: รูปเรือเขียว
  //   else if (column.dataField === "ACTIVE_ITEM") {
  //     cellElement.innerHTML = renderShipIcons(data.ACTIVE_ITEM, ship_green);
  //     cellElement.style.textAlign = "left";
  //   }

  //   // INACTIVE_ITEM: รูปเรือแดง
  //   else if (column.dataField === "INACTIVE_ITEM") {
  //     cellElement.innerHTML = renderShipIcons(data.INACTIVE_ITEM, ship_red);
  //     cellElement.style.textAlign = "left";
  //   }

  //   // CARGO_TYPE: Emoji แบบ map
  //   else if (column.dataField === "CARGO_TYPE") {
  //     const cargoMap = {
  //       FAK: "📦 FAK",
  //       REEFER: "🧊 REEFER",
  //       FOOD: "🍽️ FOOD",
  //       GARMENT: "👗 GARMENT",
  //       NAC: "👨🏻‍💼 NAC",
  //       DG: "☠️ DG",
  //     };
  //     const cargoLabel = cargoMap[data.CARGO_TYPE];
  //     if (cargoLabel) {
  //       cellElement.innerHTML = `<p style="text-align:left;">${cargoLabel}</p>`;
  //     }
  //   }

  //   // LOADTYPE: สีพื้นต่างกันตามประเภท
  //   else if (column.dataField === "LOADTYPE") {
  //     const yellowTypes = ["FCL", "DIRECT-FCL", "CONSOLE"];
  //     const blueTypes = ["LCL", "DIRECT-LCL"];
  //     if (yellowTypes.includes(data.LOADTYPE)) {
  //       cellElement.innerHTML = `<p style="background-color:#ffd365; text-align:center;">${data.LOADTYPE}</p>`;
  //     } else if (blueTypes.includes(data.LOADTYPE)) {
  //       cellElement.innerHTML = `<p style="background-color:#abffff; text-align:center;">${data.LOADTYPE}</p>`;
  //     }
  //   }
  // };

  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);

  //end column chooser
  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {}).format(value);
  const Search = () => {
    const [showResults, setShowResults] = React.useState(false);
    const onClick = () => setShowResults(true);
    return (
      <div>
        <input type="button" value="Search" onClick={onClick} />
        {showResults ? <Results /> : null}
      </div>
    );
  };
  const Results = () => (
    <div id="results" className="search-results">
      Some Results
    </div>
  );
  const customStyles = {
    control: (provided) => ({
      // class attribute : class=" css-i32vvf-control"
      ...provided,
      fontSize: 14,
      background: "#119f4a",
      color: "white",
      display: "flex",
      flexWrap: "nowrap",
      width: "15em",
    }),
    menu: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      background: "white",
      color: "#333",
    }),
    select: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      fontSize: 14,
      color: "blue",
    }),
    option: (provided) => ({
      // 'menu' is from the div class too.
      ...provided,
      fontSize: 14,
    }),
    input: (provided) => ({
      ...provided,
      fontSize: 14,
      color: "white",
      width: "80px !important",
      border: "none",
      margin: "0px 0px 0px 0px",
    }),
  };
  // 3	Reject
  // 4	Wait Carrier Release
  // 5	Wait Sales to confirm
  // 6	Sales confirm
  // 7	BSE Created
  // 8	BSE PreConfirm
  // 10	BSE Confirmed
  // 9	Cancel
  // 11	Open Job
  // const isEdit = (ORDER_STATUS) =>
  //   ORDER_STATUS && ["6", "7", "8","10","11"].indexOf(ORDER_STATUS) >= 0;
  const isEdit = (ORDER_STATUS) =>
    ORDER_STATUS && ["11"].indexOf(ORDER_STATUS) >= 0;
  const isEditIconVisible = (e) => !isEdit(e.row.data.ORDER_STATUS);

  const isDel = (status) =>
    status && ["0"].indexOf(status.trim().toUpperCase()) >= 0;
  const isDelelteIconVisible = (e) => isDel(e.row.data.ORDER_STATUS);

  const isCF = (status) =>
    status && ["5"].indexOf(status.trim().toUpperCase()) >= 0;
  const isCFIconVisible = (e) => isCF(e.row.data.ORDER_STATUS);

  const isDraft = (status) =>
    status && ["0"].indexOf(status.trim().toUpperCase()) >= 0;
  const isCopyIconVisible = (e) => !isDraft(e.row.data.ORDER_STATUS);

  const isBooking = (status) =>
    status && ["0"].indexOf(status.trim().toUpperCase()) >= 0;
  const isBookingIconVisible = (e) => isBooking(e.row.data.ORDER_STATUS);

  const onRefreshClick = () => {
    setLoadGrid(Math.random());
  };
  const updateGridData = () => {
    setLoadGrid(randomNumberInRange(1, 20));
  };
  const renderDetailSection = useCallback(({ data }) => {
    return DetailSection(data, updateGridData);
  }, []);

  // const updateGridData = useCallback(() => {
  //   setLoadGrid(Math.random());
  // }, []);

  // const renderDetailSection = useCallback(
  //   ({ data }) => <DetailSection {...data} sendDataToParent={updateGridData} />,
  //   [updateGridData]
  // );

  function onShowlogButtonClick(e) {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    fetchItemData(e.row.key);
    setShowLog(true);
  }
  const showLogData = true;
  const fetchItemData = async (ORDER_ID) => {
    const response = await fetch(
      api_path + "/GET_ORDER_LOG.php?ORDER_ID=" + ORDER_ID
    );
    const data = await response.json();
    setLogData(data);
  };
  function DisplayLogData(props) {
    if (props.logData.length > 0) {
      return (
        <table class="table table-Default table-hover">
          <thead>
            <tr>
              <th scope="col">STATUS</th>
              <th scope="col">DATE</th>
              <th scope="col">Modified By</th>
              <th scope="col">DETAIL</th>
              <th scope="col">REMARK</th>
            </tr>
          </thead>
          {showLogData ? (
            <>
              {logData.map((fdata) => {
                return (
                  <OrderLogDataView
                    key={fdata.INQUIRY_ITEM_ID}
                    id={fdata.ORDER_ID}
                    STATUS_ID={fdata.STATUS_ID}
                    STATUS={fdata.STATUS}
                    USERNAME={fdata.USERNAME}
                    EVENT_DATE={fdata.EVENT_DATE}
                    DATE_TEXT={fdata.DATE_TEXT}
                    REMARK={fdata.REMARK}
                    REVISED_COLUMNS={fdata.REVISED_COLUMNS}
                  />
                );
              })}
            </>
          ) : (
            <p>You cannot see the data</p>
          )}
        </table>
      );
    } else {
    }
  }
  const [modeSize, setModeSize] = useState("widget");
  // icon ship
  const ShipIcons = React.memo(({ count, icon }) => {
    const total = parseInt(count, 10) || 0;
    return (
      <>
        {Array.from({ length: total }).map((_, i) => (
          <img key={i} src={icon} width={16} alt="" />
        ))}
      </>
    );
  });

  // Status cell
  const StatusCell = React.memo(({ data }) => {
    const textColor = data.ORDER_STATUS === "0" ? "#000" : "#fff";

    return (
      <p className={`status${data.ORDER_STATUS}`}>
        <a
          href={`SalesOrderDetail?order_id=${data.ORDER_ID}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: textColor }}
          title="View Order"
        >
          {data.ORDER_STATUS_NAME}
        </a>
      </p>
    );
  });

  // Order no cell
  const OrderNoCell = React.memo(({ data }) => (
    <p
      style={{ color: "#000", backgroundColor: "#EBEBEB", textAlign: "center" }}
    >
      <a
        href={`SalesOrderDetail?order_id=${data.ORDER_ID}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#000" }}
        title="View Order"
      >
        {data.ORDER_NO}
      </a>
    </p>
  ));

  // Cargo type cell
  const CargoTypeCell = React.memo(({ value }) => {
    const cargoMap = {
      FAK: "📦 FAK",
      REEFER: "🧊 REEFER",
      FOOD: "🍽️ FOOD",
      GARMENT: "👗 GARMENT",
      NAC: "👨🏻‍💼 NAC",
      DG: "☠️ DG",
    };
    return <span>{cargoMap[value] || value}</span>;
  });

  // Load type cell
  const LoadTypeCell = React.memo(({ value }) => {
    const yellowTypes = ["FCL", "DIRECT-FCL", "CONSOLE"];
    const blueTypes = ["LCL", "DIRECT-LCL"];

    let bg = "";
    if (yellowTypes.includes(value)) bg = "#ffd365";
    if (blueTypes.includes(value)) bg = "#abffff";

    return <p style={{ backgroundColor: bg, textAlign: "center" }}>{value}</p>;
  });
  return (
    <Container maxWidth="xl">
      <Modal
        className="modal"
        show={showLog}
        onHide={handleCloseLog}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sales Order Log</Modal.Title>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <br />
            <DisplayLogData logData={logData} />
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Footer>
      </Modal>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <label className="head">Sales Order</label>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>
        <Grid
          item
          xs={12}
          sm={3}
          style={{ display: "flex" }}
          justify="flex-end"
        >
          <Select
            className="menu"
            styles={customStyles}
            placeholder="New"
            options={optionsButton}
            onChange={handleButtonNewChange}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <label>Create Date From</label>
          <DateBox
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateFrom}
            onValueChanged={onValueChangedDateFrom}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>To</label>
          <DateBox
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateTo}
            min={getMinDate}
            onValueChanged={onValueChangedDateTo}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>BOOKING REF</label>
          <TextField
            size="small"
            name="GET_REFNO"
            variant="outlined"
            fullWidth
            id="GET_REFNO"
            value={GET_REFNO}
            onChange={(e) => SET_REFNO(e.target.value)}
          />
        </Grid>
        {/* )}
                     {showManager && ( */}
        <Grid item xs={12} sm={2}>
          <label>BOOKING NO</label>
          <TextField
            size="small"
            name="GET_BOOKNO"
            variant="outlined"
            fullWidth
            id="GET_BOOKNO"
            value={GET_BOOKNO}
            onChange={(e) => SET_BOOKNO(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <label>SMF REF</label>
          <TextField
            size="small"
            name="GET_SMFREF"
            variant="outlined"
            fullWidth
            id="GET_SMFREF"
            value={GET_SMFREF}
            onChange={(e) => SET_SMFREF(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}></Grid>
        <Grid item xs={12} sm={2}>
          <label>SALES</label>
          <Select
            defaultValue={"-"}
            className="multiselect1"
            placeholder="Select..."
            value={getSale}
            options={saleList}
            onChange={handleSaleChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Customer</label>
          <Select
            className="multiselect2"
            placeholder="Select..."
            value={getShipper}
            options={shipperList}
            onChange={handleShipperChange}
            getOptionLabel={(x) => x.COM_NAME}
            getOptionValue={(x) => x.COM_CODE}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Consignee</label>
          <Select
            className="multiselect3"
            placeholder="Select..."
            value={getConsignee}
            options={consigneeList}
            onChange={handleConsigneeChange}
            getOptionLabel={(x) => x.COM_NAME}
            getOptionValue={(x) => x.COM_CODE}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Status</label>
          <Select
            className="multiselect4"
            placeholder="Select"
            value={getStatus}
            options={optionsStatus}
            onChange={handleStatusChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className="paddingSearchButton">&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={onRefreshClick}
          >
            Refresh data
          </Button1>
        </Grid>
        <Grid item xs={12} sm={2}></Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <div className="labelError">{getResult}</div>
          <div className="labelResult">{getDateStr}</div>
        </Grid>
      </Grid>

      <Grid container className={classes.root}>
        <DataGrid
          id="SalesOrderContainer"
          //onCellPrepared={cellPrepared}
          dataSource={salesOrderDataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="ORDER_ID"
          onExporting={onExporting}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
          hoverStateEnabled={true}
          // remoteOperations={{
          //   paging: true,
          //   sorting: true,
          //   filtering: false,
          // }}
          // remoteOperations={{
          //   paging: true,
          //   filtering: true,
          //   sorting: true,
          // }}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>

          <StateStoring
            enabled={true}
            type="localStorage"
            storageKey="storageSalesOrder"
          />
          <ColumnFixing enabled={false} />
          <MasterDetail enabled={true} render={renderDetailSection} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column
            dataField="ORDER_ID"
            defaultSortOrder="desc"
            visible={false}
          />
          <Column
            dataField="ORDER_NO"
            caption="SO NO."
            width={80}
            cellRender={({ data }) => <OrderNoCell data={data} />}
          />
          <Column
            dataField="ORDER_DATE"
            caption="SO Date"
            dataType="date"
            format="dd-MMM-yyyy"
            width={70}
            sortOrder="desc"
          />
          <Column
            dataField="CUSTOMER_REF"
            caption="CUST. REF"
            width={100}
            allowResizing={false}
          />
          <Column dataField="SHIPPER_NAME" caption="Customer" width={180} />
          <Column dataField="CNEE_NAME" caption="CNEE" width={180} />
          <Column
            dataField="CNT20"
            caption="20'"
            allowResizing={true}
            width={60}
            alignment="center"
          />
          <Column
            dataField="CNT40"
            caption="40'"
            allowResizing={true}
            width={60}
            alignment="center"
          />
          <Column
            dataField="CNT40HQ"
            caption="40HQ"
            allowResizing={true}
            width={60}
            alignment="center"
          />
          <Column
            dataField="CNT45"
            caption="45'"
            allowResizing={true}
            width={60}
            alignment="center"
          />
          <Column dataField="POR" visible={false} />
          <Column dataField="POL" width={60} />
          <Column dataField="POD" width={60} />
          <Column dataField="DEL" width={60} />
          <Column dataField="FINAL" width={60} />
          <Column
            dataField="CARRIER_CODE"
            caption="CARRIER"
            width={100}
            visible={false}
          />
          <Column
            dataField="SERVICES_CONTRACT"
            caption="S/C"
            width={120}
            visible={false}
          />
          <Column
            dataField="CARGO_READY"
            caption="CRD"
            dataType="date"
            format="dd-MMM-yyyy"
            width={70}
          />
          <Column
            dataField="ETD_DATE"
            caption="ETD"
            dataType="date"
            format="dd-MMM-yyyy"
            width={70}
          />
          <Column
            dataField="ETA_DATE"
            caption="ETA"
            dataType="date"
            format="dd-MMM-yyyy"
            visible={false}
          />
          <Column
            dataField="CARGO_TYPE"
            caption="Cargotype"
            width={80}
            alignment="left"
            cellRender={({ value }) => <CargoTypeCell value={value} />}
          />
          <Column
            dataField="LOADTYPE"
            caption="Loadtype"
            width={80}
            cellRender={({ value }) => <LoadTypeCell value={value} />}
          />
          <Column
            dataField="INCOTERM"
            caption="Incoterm"
            width={80}
            alignment="center"
          />
          <Column
            dataField="ACTIVE_ITEM"
            caption="Active"
            width={65}
            allowFiltering={false}
            allowHeaderFiltering={false}
            cellRender={({ value }) => (
              <ShipIcons count={value} icon={ship_green} />
            )}
          />
          <Column
            dataField="INACTIVE_ITEM"
            caption="Inactive"
            width={50}
            allowFiltering={false}
            allowHeaderFiltering={false}
            cellRender={({ value }) => (
              <ShipIcons count={value} icon={ship_red} />
            )}
          />
          <Column
            dataField="ORDER_STATUS_NAME"
            caption="Status"
            width={100}
            cellRender={({ data }) => <StatusCell data={data} />}
          />
          <Column dataField="CREATE_BY" caption="Creater" width={80} />
          <Column dataField="CS_NAME" caption="CS" width={80} />
          <Column dataField="ORDER_STATUS" visible={false} />
          <Column dataField="TYPE20" visible={false} />
          <Column dataField="TYPE40" visible={false} />
          <Column dataField="TYPE40HQ" visible={false} />
          <Column dataField="TYPE45" visible={false} />
          <Column dataField="GW" visible={false} />
          <Column dataField="NO_OF_PACK" visible={false} />
          <Column dataField="PACKAGE_UNIT" visible={false} />
          <Column dataField="CBM" visible={false} />
          <Column dataField="BOOK_PRIORITY" visible={false} />
          <Column dataField="WAITING_FLAG" visible={false} />
          <Column
            type="buttons"
            caption="Actions"
            fixed={true}
            allowFiltering={false}
            allowHeaderFiltering={false}
          >
            <Button
              icon="edit"
              onClick={onEditButtonClick}
              hint="Click to edit order"
            />
            <Button
              icon="eyeopen"
              onClick={onShowlogButtonClick}
              hint="Click to view log details"
            />
            <Button
              icon="copy"
              onClick={onCopyButtonClick}
              hint="Click to copy order"
              visible={isCopyIconVisible}
            />
            <Button
              icon="message"
              onClick={onBookingButtonClick}
              hint="Click to send order"
              visible={isBookingIconVisible}
            />
            <Button
              icon="trash"
              onClick={onDeleteButtonClick}
              hint="Delete"
              visible={isDelelteIconVisible}
            />
          </Column>
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
            <Summary>
                      <TotalItem
                        column="ORDER_NO"
                        summaryType="count"
                        valueFormat={{ type: "fixedPoint", precision: 0 }} // รวมเป็น sum, มี comma
                        displayFormat="Total: {0}"
                      />
                    </Summary>
        </DataGrid>
      </Grid>
    </Container>
  );
}
const DetailSection = (data, updateGridData) => {
  return (
    <SaleOrderMasterDetailView
      ORDER_ID={data.ORDER_ID}
      ORDER_STATUS={data.ORDER_STATUS}
      SHIPPER_CODE={data.SHIPPER_CODE}
      CNEE_CODE={data.CNEE_CODE}
      CARRIER_CODE={data.CARRIER_CODE}
      SERVICES_CONTRACT={data.SERVICES_CONTRACT}
      BULLET_CODE={data.BULLET_CODE}
      SCAC={data.SCAC}
      CNT20={data.CNT20}
      CNT40={data.CNT40}
      CNT40HQ={data.CNT40HQ}
      CNT45={data.CNT45}
      TYPE20={data.TYPE20}
      TYPE40={data.TYPE40}
      TYPE40HQ={data.TYPE40HQ}
      TYPE45={data.TYPE45}
      GW20={data.GW20}
      GW40={data.GW40}
      GW40HQ={data.GW40HQ}
      GW45={data.GW45}
      GW={data.GW}
      BOOK_PRIORITY={data.BOOK_PRIORITY}
      WAITING_FLAG={data.WAITING_FLAG}
      POR={data.POR}
      POL={data.POL}
      POD={data.POD}
      DEL={data.DEL}
      FINAL={data.FINAL}
      INLAND_POSTCODE={data.INLAND_POSTCODE}
      USER_ID={data.USER_ID}
      sendDataToParent={updateGridData}
    />
  );
};
